import { LinkSimpleIcon } from "@phosphor-icons/react";

const host = (url) => {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
};

// Web sources Gamly used for an answer.
export default function AnswerSources({ sources, testId = "answer-sources" }) {
  if (!sources?.length) return null;
  return (
    <div className="mt-2 pt-2 border-t border-white/10 flex flex-wrap gap-1.5" data-testid={testId}>
      {sources.map((s) => (
        <a
          key={s.url}
          href={s.url}
          target="_blank"
          rel="noopener noreferrer"
          title={s.title}
          className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-white/5 hover:bg-white/10 text-[10px] font-semibold text-white/55 hover:text-white transition-colors"
        >
          <LinkSimpleIcon size={10} /> {host(s.url)}
        </a>
      ))}
    </div>
  );
}
